import { Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { AI_API_KEY, AI_API_URL, TICKET_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import { createTheme, useTheme, ThemeProvider } from "@mui/material";
import { isEmpty } from "../../Constants/RolesConstants";
import { STATUS_CLOSED_ID } from '../../Constants/StatusConstants'

function AI(props) {
  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {
      MuiSelect: {
        defaultProps: {
          sx: {
            paddingLeft: "20px",
          },
        },
      },
      MuiButton: {
        defaultProps: {
          sx: {
            marginTop: 2,
            marginBottom: 2,
            display: "block",
          },
        },
      },
    },
  });

  const [subject, setSubject] = useState("");
  const [result, setResult] = useState("");
  const [parts, setParts] = useState([]);
  const [payload, setPayload] = useState({});
  const [loading, setLoading] = useState(false);
  const [ticket, setTicket] = useState({});
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getTicketInfo();
    }
  }, [result]);

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
  };

  const getTicketInfo = async () => {
    await AxiosInstance.get(`${TICKET_URL}/${props.ticketId}`).then((response) => {
      console.log(response.data);
      setTicket(response.data);
      setSubject(response.data.subject + "\n" + response.data.description);
      setLoading(false);
    });
  };

  const handleSend = (event) => {
    setPayload({
      messages: [
        {
          role: "system",
          content:
            "Provide UI based step-by-step strectured answers answers for every question without any code examples or PowerShell commands and links",
        },
        {
          role: "user",
          content: subject,
        },
      ],
      temperature: 0.5,
      top_p: 0.9,
      top_k: 50,
      frequency_penalty: 0.1,
      presence_penalty: 0.2,
      repetition_penalty: 1.1,
      seed: 123456,
      model: "meta-llama/llama-3.2-3b-instruct:free",
    });
    setLoading(true);
    axios
      .post(AI_API_URL, payload, {
        headers: {
          Authorization: `Bearer ${AI_API_KEY}`,
        },
      })
      .then((response) => {
        console.log("response:", response.data.choices[0].message.content);
        setResult(response.data.choices[0].message.content);
        setParts(response.data.choices[0].message.content.split("\n\n"));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ padding: '20px', bgcolor: 'background.default' }}>
        <>
          <Row>
            <Form.Group as={Col} controlId="formGridComment">
              {/* <Form.Control type="text" value={subject} placeholder="Ask anything" onChange={handleSubjectChange} /> */}
              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="Subject"
                label="Subject"
                placeholder="Ask anything"
                fullWidth
                multiline
                rows={4}
                cols={10}
                value={subject}
                onChange={handleSubjectChange}
                style={{ width: "100%" }}
                disabled={props.statusId === STATUS_CLOSED_ID}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridCommentPost">
              {isEmpty(props?.componentPermissions) ||
                props?.componentPermissions?.["canUpdate"] ? (
                <Button
                  disabled={props.statusId === STATUS_CLOSED_ID}
                  as="input"
                  rows={2}
                  type="button"
                  value="Send"
                  style={{ backgroundColor: "#0d6efd", color: "white" }}
                  onClick={() => handleSend()}
                />
              ) : null}
            </Form.Group>
          </Row>
          {loading ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress />
            </Box>
          ) : (
            <Row>
              <Typography>
                {parts.map((part, index) => (
                  <p key={index}>{part}</p> // 👈 render each part as a <p> paragraph
                ))}
              </Typography>
            </Row>
          )}
        </>
      </Box>
    </ThemeProvider>
  );
}
export default AI;
